import { render, staticRenderFns } from "./InvoiceImportingWithholdings.vue?vue&type=template&id=47e75c84&scoped=true"
import script from "./InvoiceImportingWithholdings.vue?vue&type=script&lang=js"
export * from "./InvoiceImportingWithholdings.vue?vue&type=script&lang=js"
import style0 from "./InvoiceImportingWithholdings.vue?vue&type=style&index=0&id=47e75c84&prod&scoped=true&lang=css"
import style1 from "./InvoiceImportingWithholdings.vue?vue&type=style&index=1&id=47e75c84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e75c84",
  null
  
)

export default component.exports